import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { AddTypeColor, getAllTypeAndColor } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import * as R from "ramda";
import ExpandType from "./components/ExpandType";
import { toggleNAluminiumUpvc } from "Constants/Constants";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import StatusHandler from "Helpers/StatusHandler";
import ProfileService from "Services/http/endpoints/properties/ProfileService";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function TypeColorSetting() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { allTypeColors } = useSelector((state) => ({
    allTypeColors: state.profile.allTypeColors,
  }));

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [colorData, setColorData] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [controls, setControls] = useSetState({
    nameType: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
    },
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    const { struct, nameType } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        const IdStruct = struct.value.value === "upvc" ? 1 : 2;
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: nameType.value,
          IdStruct: IdStruct,
        };
        await dispatch(AddTypeColor(data));
        //todo seo
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllTypeAndColor(params));
        onClear();
      } catch (err) {
      console.error('[catch error]', err)
    }
    } else {
      setCheckValid(true);
    }
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      await dispatch(getAllTypeAndColor(params));
      const paramsColor = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      const response = await ProfileService.getColor(paramsColor);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const colorList = response.data.Value;
        const items = colorList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        setColorData(items);
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const onClear = () => {
    setCheckValid(false);
    setExpanded(null);
    setFormValid({});
    setControls({ nameType: { value: "" } });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = (isOnClose = false) => {
    if (isOnClose) onClear();
    setOpenDialog(!openDialog);
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const handleChangeAccordion = (value) => {
    if(expanded === value) setExpanded(null);
    else setExpanded(value);
  }

  return (
    <>
      <MuiButton
        loading={loading}
        color="secondary"
        title={<Translator id={"profileTypeColor"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={() => handleDialog(true)}
        onEnter={onEnter}
        fullWidth
        maxWidth="md"
      >
        <div className="dialogHeader">
          <p>{<Translator id={"profileTypeColorSetting"} />}</p>
        </div>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              container
              spacing={2}
              hidden={!read("typeColorRules").accessRegister}
            >
              <Grid item md={4} sm={6} xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  name="nameType"
                  validation={controls.nameType.validation}
                  placeholder={t("nameType")}
                  value={controls.nameType.value}
                  label={<Translator id="nameType" />}
                  type="text"
                  checkValid={checkValid}
                />
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <MuiRadioGroup
                  name={"struct"}
                  label={t("struct")}
                  value={controls.struct.value}
                  items={controls.struct.arrayItems}
                  onChange={onChangeToggle}
                  translate={true}
                  className="horizontalRadio"
                />
              </Grid>
              <Grid
                item
                md={4}
                sm={6}
                xs={12}
                className="d-flex flex-row align-items-center"
              >
                <MuiButton
                  loading={loading}
                  color="primary"
                  title={<Translator id="ezafe_be_list" />}
                  onClick={onSubmit}
                  fullwidthOnSm
                  disabled={!read("typeColorRules").accessRegister}
                />
              </Grid>
            </Grid>
            <Divider className="my-3" />
            <span className="normalTitle mb-3">{t("ProfileTypeList")}</span>
            <Grid container spacing={2}>
              {!loading ? (
                allTypeColors.map((group, i) => {
                  return (
                    <Grid item xs={12} key={group.Id} className="paper-no-padding">
                      <ExpandType
                        row={allTypeColors[i]}
                        colorData={colorData}
                        expanded={expanded}
                        onChange={handleChangeAccordion}
                      />
                    </Grid>
                  );
                })
              ) : (
                <MuiSkeleton xs={12} number={4} />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TypeColorSetting;
